module.exports = __webpack_public_path__ + "media/img/private-venue/hover-private-dafb80acf3c6972525a5c13ece0b77d2.svg";